import { GenericCrudPage } from '@/components/GenericCrudPage';
import { questionGroupsConfig } from '@/pages/configs';

export default function QuestionGroupsPage() {
  return <GenericCrudPage config={questionGroupsConfig} />;
}
